var path = 'customer/customer-card.tpl.html';
var html = "\n<div ng-show=\"item && (!item.additionalInfo || !item.additionalInfo.isPublic)\" class=\"tb-uppercase\">{{ item | contactShort }}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/customer/customer-card.tpl.html
// module id = 1426
// module chunks = 1